export default "__VITE_ASSET__ff04346b__"